import { LazyBreadcrumb, useDumbActionsContext } from '@europrocurement/flexy-components';
import {
    FactureOpenSearch,
    FactureOpenSearchSelector,
    FACTURES_OPEN_SEARCH_SLICE_NAME,
    useFacturationService,
} from '@europrocurement/l2d-domain';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FacturesTable, useDefaultContextActions } from '@europrocurement/l2d-modules';
import { AnyAction } from '@reduxjs/toolkit';
import { useFormalitiesInvoicesBackHook } from '../../hooks';

export const InvoicesFormalitiesListBack: React.FunctionComponent = function () {
    const dispatch = useDispatch();
    const [isReady, setIsReady] = useState(false);
    const datasource: DataSource<FactureOpenSearch> = useSelector(FactureOpenSearchSelector);
    const { backContextActions } = useDefaultContextActions();
    useDumbActionsContext(backContextActions);

    /** Formality Domain 3 */
    const ddmIdFilter: number = 3;

    const { columns, filters, rowActions, preFilters } = useFormalitiesInvoicesBackHook({
        ddmIdFilter,
    });
    const { getFactureOpenSearch } = useFacturationService();

    const breadcrumbItems = [
        {
            link: '/accueil',
            icon: {
                icon: ['fasl', 'house'] as IconProp,
                sx: { display: 'flex', alignItems: 'center' },
            },
        },
        {
            link: '/formalites/factures',
            path: 'Formalités',
        },
        'Mes factures',
    ];

    useEffect(() => {
        dispatch({
            type: `${FACTURES_OPEN_SEARCH_SLICE_NAME}/setmainFilter`,
            payload: {
                key: 'ddmId',
                value: ddmIdFilter,
            },
        });
        setIsReady(true);
    }, [ddmIdFilter, dispatch]);

    // reFetch factures api datas
    useEffect(() => {
        dispatch(getFactureOpenSearch({}) as unknown as AnyAction);
    }, [dispatch, getFactureOpenSearch]);

    return (
        <>
            <LazyBreadcrumb
                path={breadcrumbItems}
                separator=" / "
                sx={{ marginBottom: '1.5em' }}
            />
            {isReady && (
                <FacturesTable
                    datasource={datasource}
                    preFilters={preFilters}
                    columns={columns}
                    filters={filters}
                    fetchData={getFactureOpenSearch}
                    rowActions={rowActions}
                    onRowClick={() => {}}
                />
            )}
        </>
    );
};
